import { render, staticRenderFns } from "./OrderAsideBidNew.vue?vue&type=template&id=752f9a8d&scoped=true&"
import script from "./OrderAsideBidNew.vue?vue&type=script&lang=js&"
export * from "./OrderAsideBidNew.vue?vue&type=script&lang=js&"
import style0 from "./OrderAsideBidNew.vue?vue&type=style&index=0&id=752f9a8d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752f9a8d",
  null
  
)

export default component.exports